import React, {useEffect, useRef} from 'react';
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger';

import load_post from '../../../assets/media/home-page/load-post.png';
import received_offer from '../../../assets/media/home-page/receive_offer.jpg';

import Accept_Offer_Img from '../../../assets/media/home-page/accept_offer.jpg';
import Make_Payment_Img from '../../../assets/media/home-page/Make_Payment.jpg';
import Detach_For_Load_Img from '../../../assets/media/home-page/detach_for_load.jpg';
import Pick_Up_Img from '../../../assets/media/home-page/pick_up.jpg';
import Deliver_Img from '../../../assets/media/home-page/deliver.jpg';
import Release_Payment_Img from '../../../assets/media/home-page/release_payment.png';


import TittleWithAnimation from './TittleWithAnimation'





var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
var container_height = (viewportHeight * 75) / 100 ;


const HowItWork = () => {
    const work_section = useRef();

    gsap.registerPlugin(ScrollTrigger);
    
    
    useEffect(()=> {
        
        var how_it_work_sections = work_section.current.childNodes;
        var how_it_work_child = [];

        for(let i=0; i< how_it_work_sections.length ; i++){
            how_it_work_child = [...how_it_work_child, how_it_work_sections[i].childNodes[0]];
        };
        
        if(viewportWidth > 1000){
            
            for(let i=0; i<(how_it_work_sections.length-1); i++){
                gsap.to(how_it_work_child[i], {
                    scrollTrigger: {
                        trigger: how_it_work_sections[i],
                        start: "bottom bottom",
                        scrub: true
                    },
                    css: {
                        position: 'fixed',
                        bottom: 200
                    }
                });
            
                gsap.to(how_it_work_child[i], {
                    scrollTrigger: {
                        trigger: '#how-it-work',
                        end: `bottom ${container_height+80}`,
                        scrub: true
                    },
                    css: {
                        display: 'none'
                    }
                });
            };
            
            for(let i=0; i<how_it_work_child.length; i++){
                how_it_work_child[i].style.height = `${container_height}px`;
                how_it_work_sections[i].style.height = `${container_height}px`;
            };
        };
        
    }, [work_section]);





    return (
        <section id="how-it-work">
            <div className="container">
                <div className="col-lg-6 ml-auto">
                    <div className="small-and-big-tittle px-5">
                        <p>Poncor Dispatch Marketplace</p>
                        <h1>
                            <TittleWithAnimation
                                word="How It Works"
                                _start="0px top"
                            />
                        </h1>
                    </div>
                </div>
            </div>

            <div ref={work_section}>
                <div className="how-it-work-wrapper" how-it-work-section="1">
                    <div className="how-it-work-child">
                        <How_it_work_box 
                            img_url = {load_post}
                            name = "Load Feed"
                        />
                        <How_it_work_box 
                            img_url = {received_offer}
                            name = "Receive Offer"
                        />
                    </div>
                </div>

                <div className="how-it-work-wrapper" how-it-work-section="2">
                    <div className="how-it-work-child">
                        <How_it_work_box 
                            img_url = {Accept_Offer_Img}
                            name = "Accept Offer"
                        />
                        <How_it_work_box 
                            img_url = {Make_Payment_Img}
                            name = "Make Payment"
                        />
                    </div>
                </div>

                <div className="how-it-work-wrapper" how-it-work-section="3">
                    <div className="how-it-work-child">
                        <How_it_work_box 
                            img_url = {Detach_For_Load_Img}
                            name = "Detach For Load"
                        />
                        <How_it_work_box 
                            img_url = {Pick_Up_Img}
                            name = "Pick up"
                        />
                    </div>
                </div>

                <div className="how-it-work-wrapper" how-it-work-section="4">
                    <div className="how-it-work-child">
                        <How_it_work_box 
                            img_url = {Deliver_Img}
                            name = "Deliver"
                        />
                        <How_it_work_box 
                            img_url = {Release_Payment_Img}
                            name = "Release Payment"
                        />
                    </div>
                </div>
            </div>

        </section>
    )
}

export default HowItWork;



const How_it_work_box = ({img_url , name}) => (
    <div className="how-it-work-wrapper-box">
        <img src={img_url} alt="img"/>
        <div className="how-it-work-subject">
                <h1>{name}</h1>
                <i className="fa-solid fa-arrow-right-long"></i>
            {/* <a href="#">
            </a> */}
        </div>
    </div>
);